export default __webpack_public_path__ + "static/media/Vincent_Van_Gogh_The_Starry_Night_40_x_60_cm.30604187.jpg";